import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

async function hashEmail(email: string): Promise<string> {
  const encoded = new TextEncoder().encode(email)
  const digest = await crypto.subtle.digest('SHA-256', encoded)
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

export function useSentryUser(
  user: { email: string; org?: string } | null,
): void {
  const email = user?.email ?? null
  const org = user?.org ?? null

  useEffect(() => {
    if (!email) {
      Sentry.setUser(null)
      Sentry.setTag('org', undefined)
      return
    }

    hashEmail(email).then((id) => {
      Sentry.setUser({ id, email })
      Sentry.setTag('org', org)
    })
  }, [email, org])
}
